'use strict';

var tslib_es6 = require('./tslib.es6-cce58b3a.js');
var Axios = require('axios');
var getUrl = require('./get-url-e43acd83.js');
require('./cookies-46b3ee01.js');
require('next-cookies');
require('./_commonjsHelpers-3fc1f64e.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var Axios__default = /*#__PURE__*/_interopDefaultLegacy(Axios);

var reportHttpError = function (e, url, config) {
  var msg = "CGI Request Error: [url]: ".concat(url, ", [data]: ").concat(JSON.stringify(config), ", [error info]: ").concat(e);
  if (window.nextAegis) {
    window.nextAegis.report(msg, e);
  }
};
// 业务逻辑是否存在异常
var CalendarRequest = /** @class */function () {
  // ticketToken: string;
  // 初始化请求库
  function CalendarRequest(_a) {
    var timeout = _a.timeout,
      base_url = _a.base_url,
      _b = _a.headers,
      headers = _b === void 0 ? {} : _b,
      _c = _a.requestMiddleware,
      requestMiddleware = _c === void 0 ? [] : _c,
      _d = _a.responseMiddleware,
      responseMiddleware = _d === void 0 ? [] : _d,
      _e = _a.extendsPlugin,
      extendsPlugin = _e === void 0 ? [] : _e,
      onTokenCheckFail = _a.onTokenCheckFail;
    var _this = this;
    this.http = Axios__default["default"].create({
      timeout: timeout
    });
    this.onTokenCheckFail = onTokenCheckFail;
    this.http.interceptors.request.use(function (config) {
      var axiosConfig = config;
      axiosConfig.baseURL = base_url;
      axiosConfig.headers = tslib_es6.__assign(tslib_es6.__assign({
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }, config.headers), headers);
      return axiosConfig;
    });
    requestMiddleware.map(function (item) {
      _this.http.interceptors.request.use(item);
    });
    responseMiddleware.map(function (item) {
      _this.http.interceptors.response.use(item);
    });
    extendsPlugin.map(function (item) {
      var _a;
      (_a = item.init) === null || _a === void 0 ? void 0 : _a.call(item, _this);
    });
  }
  // post请求
  CalendarRequest.prototype.post = function (prefix, path, data, ctx, query, rawRes, axiosConfig) {
    if (query === void 0) {
      query = {};
    }
    return tslib_es6.__awaiter(this, void 0, void 0, function () {
      var config, postParams, _a, url, callback, startTime, response, httpDuration;
      var _this = this;
      return tslib_es6.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4 /*yield*/, getUrl.getReqConfig(ctx)];
          case 1:
            config = _b.sent();
            postParams = [prefix, path, data, ctx, query, rawRes, axiosConfig];
            config.params = tslib_es6.__assign(tslib_es6.__assign({}, config.params), query);
            if (axiosConfig) {
              config = tslib_es6.__assign(tslib_es6.__assign({}, config), axiosConfig);
            }
            return [4 /*yield*/, getUrl.getUrl({
              prefix: prefix,
              path: path,
              ctx: ctx
            })];
          case 2:
            _a = _b.sent(), url = _a.url, callback = _a.callback;
            startTime = new Date().getTime();
            return [4 /*yield*/, this.http.post(url, data, config).catch(function (e) {
              return tslib_es6.__awaiter(_this, void 0, void 0, function () {
                var _a;
                return tslib_es6.__generator(this, function (_b) {
                  callback(false, 0, '-1');
                  // 错误统一上报
                  reportHttpError(e, url, config);
                  if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && this.onTokenCheckFail) {
                    return [2 /*return*/, this.onTokenCheckFail(postParams, this.post)];
                  }
                  return [2 /*return*/, Promise.reject(e)];
                });
              });
            })];
          case 3:
            response = _b.sent();
            httpDuration = new Date().getTime() - startTime;
            callback(true, httpDuration, '0');
            return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
      });
    });
  };
  // get请求
  CalendarRequest.prototype.get = function (prefix, path, query, ctx, rawRes) {
    return tslib_es6.__awaiter(this, void 0, void 0, function () {
      var config, getParams, _a, url, callback, startTime, params, response, httpDuration;
      var _this = this;
      return tslib_es6.__generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4 /*yield*/, getUrl.getReqConfig(ctx)];
          case 1:
            config = _b.sent();
            getParams = [prefix, path, query, ctx, rawRes];
            config.params = tslib_es6.__assign(tslib_es6.__assign({}, config.params), query);
            return [4 /*yield*/, getUrl.getUrl({
              path: path,
              prefix: prefix,
              ctx: ctx
            })];
          case 2:
            _a = _b.sent(), url = _a.url, callback = _a.callback;
            startTime = new Date().getTime();
            params = tslib_es6.__assign(tslib_es6.__assign({}, config.params), query);
            return [4 /*yield*/, this.http.get(url, tslib_es6.__assign(tslib_es6.__assign({}, config), {
              params: params
            })).catch(function (e) {
              return tslib_es6.__awaiter(_this, void 0, void 0, function () {
                var _a;
                return tslib_es6.__generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      callback(false, 0, '-1');
                      reportHttpError(e, url, config);
                      if (!(((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && this.onTokenCheckFail)) return [3 /*break*/, 2];
                      return [4 /*yield*/, this.onTokenCheckFail(getParams, this.get)];
                    case 1:
                      return [2 /*return*/, _b.sent()];
                    case 2:
                      return [2 /*return*/, Promise.reject(e)];
                  }
                });
              });
            })];
          case 3:
            response = _b.sent();
            httpDuration = new Date().getTime() - startTime;
            callback(true, httpDuration, '0');
            return [2 /*return*/, response === null || response === void 0 ? void 0 : response.data];
        }
      });
    });
  };
  return CalendarRequest;
}();

module.exports = CalendarRequest;
